module.exports = __webpack_public_path__ + "static/media/nu-01.76256aae.png";